import React from 'react';
import { COLORS } from '../../../game/data/colors';

interface Props {
  width: number;
  children: React.ReactNode;
  onClose: () => void;
}

export const Popup: React.FC<Props> = ({ width, children, onClose }) => {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: COLORS.backdrop,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: COLORS.zinc_800,
          borderRadius: 8,
          padding: 24,
          width: width,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};
